import React, { Component } from "react";

import AppContext from "../../appContext";

import { Redirect } from "react-router-dom";
import Alert from "sweetalert2";
import { withStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";

const styles = (theme) => ({
  logoutButton: {
    backgroundColor: "#0394db",
    color: "#fff",
    borderRadius: 50,
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.875rem",
    padding: "8px 16px",
    "&:hover": {
      backgroundColor: "#027bb5",
      color: "#f0f0f0",
    },
  },
});

class Logout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      logout: false,
      loading: false,
    };

    Logout.contextType = AppContext;
    this.logout = this.logout.bind(this);
  }

  logout(e) {
    e.preventDefault();
    if (document.getElementById("myNav"))
      document.getElementById("myNav").style.display = "block";
    if (document.getElementById("headerBtn"))
      document.getElementById("headerBtn").style.visibility = "hidden";
    if (document.getElementById("headerBtn1"))
      document.getElementById("headerBtn1").style.visibility = "hidden";
    if (document.getElementById("main-body"))
      document.getElementById("main-body").style.pointerEvents = "none";
    if (sessionStorage.getItem("token") != null) {
      const requestOptions = {
        method: "DELETE",
        body: JSON.stringify({ token: sessionStorage.getItem("token") }),
      };
      this.context.showLoading("Saindo...");
      fetch(
        process.env.REACT_APP_LABS_API + "delete_token.php",
        requestOptions
      )
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          if (json.status === 204) {
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("session_token");
            sessionStorage.removeItem("grant_token");
            localStorage.removeItem("token");
            localStorage.removeItem("session_token");
            localStorage.removeItem("grant_token");
            localStorage.removeItem("client");
            this.setState({ logout: true });
            this.context.hideLoading();
          } else {
            this.context.hideLoading();
            Alert.fire({
              text: "Erro ao efetuar Logout.",
              icon: "error",
              title: "Aviso",
              confirmButtonColor: "#00518b",
              customClass: {
                confirmButton: "x-follow-order__filter-btn",
              },
            });
            document.getElementById("myNav").style.display = "none";
            document.getElementById("headerBtn").style.visibility =
              "visible";
            document.getElementById("headerBtn1").style.visibility =
              "visible";
            document.getElementById(
              "main-body"
            ).style.pointerEvents = "";
          }
        });
    } else {
      this.setState({ logout: true });
    }
  }

  render() {
    const { classes } = this.props;
    const { logout } = this.state;

    if (logout) {
      return <Redirect to="/" />;
    }

    return (
      <Button
        className={classes.logoutButton}
        onClick={this.logout}
        fullWidth
        variant="contained"
        disableElevation
      >
        Sair
      </Button>
    );
  }
}

export default withStyles(styles)(Logout);
